import { PassengerMapStationFilterTypeEnum } from "../enums";

/** Marks the in-map control cluster on any map, so a click on it is not read as a click on the map. */
export const MAP_DATA_CONTROLS_ATTR = "data-map-controls";
export const MAP_DATA_CONTROLS_SELECTOR = `[${MAP_DATA_CONTROLS_ATTR}]`;

export const PASSENGERS_MAP_DEFAULT_FILTER_TYPE =
  PassengerMapStationFilterTypeEnum.allSelectedPassengersPickupStations;

/** How long a station just added to the passengers map stays highlighted, so the eye can find it. */
export const PASSENGERS_MAP_ADDED_STATION_HIGHLIGHT_MS = 8_000;
